module.exports = __webpack_public_path__ + "img/login.0bd1f5ed.jpg";